import { render, staticRenderFns } from "./CrmOrcamentos.vue?vue&type=template&id=214c2664&"
import script from "./CrmOrcamentos.vue?vue&type=script&lang=js&"
export * from "./CrmOrcamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports